import { render } from "./beritaacara.vue?vue&type=template&id=91d7c63a"
import script from "./beritaacara.vue?vue&type=script&lang=js"
export * from "./beritaacara.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__